module.exports = __webpack_public_path__ + "img/3.293b2c41.png";